<template>

    <div>
        <link href="/themes/web/assets/css/unit-detail.css" rel="stylesheet">

        <div class="container">
            <div id="page-header-fixed">
                <div class="">
                    <div id="page-header">
                        <!--<ul class="breadcrumb">-->
                        <!--<li class="icon"><img src="assets/images/back-to.svg" alt=""></li>-->
                        <!--<li class="active">iSmart Maths - Unit 1</li>-->
                        <!--</ul>-->
                        <div class="buttons">
                            <div class="btn-group">
                                <button v-bind:class="tab == 'report' ? 'active btn btn-default' : 'btn btn-default'"
                                    @click="changeTab('report')" type="button">{{ $t('reports') }}</button>
                                <!-- <button  v-bind:class="tab=='report'?'active btn btn-default':'btn btn-default'" @click="changeTab('report')" type="button" >{{$t('usage_reports')}}</button>
                                <button  v-bind:class="tab=='chart'?'active btn btn-default':'btn btn-default'" @click="changeTab('chart')" type="button" >{{$t('lisa_web_skill_points')}}</button> -->
                                <button v-if="user_info.student_type == 1"
                                    v-bind:class="tab == 'academic' ? 'active btn btn-default' : 'btn btn-default'"
                                    @click="changeTab('academic')" type="button">{{ $t('academic_report') }}</button>
                                <button v-if="user_info.student_type == 1"
                                    v-bind:class="tab == 'certificates' ? 'active btn btn-default' : 'btn btn-default'"
                                    @click="changeTab('certificates')" type="button">{{ $t('certificates') }}</button>
                                <button v-if="user_info.student_type == 1 && hasIclass"
                                    v-bind:class="tab == 'iclassreport' ? 'active btn btn-default' : 'btn btn-default'"
                                    @click="changeTab('iclassreport')" type="button">{{ $t('iCLASS') }}</button>
                                <!-- <router-link :to="{ name: 'parent_certificate' }" @click.native="getSoundClick">
                                    <button type="button" class="btn btn-default active">{{$t('certificate')}}</button>
                                </router-link> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="tab == 'report'" class="card reports">
                <div class="card-header">
                    <div class="card-title">{{ $t('lisa_web_program_report') }}</div>
                </div>
                <div class="card-body" style="padding-left:90px">
                    <div class="card-content">
                        <div v-if="report_program.length > 0">
                            <template v-for="(sbj, i) in report_program">
                                <h4 class="title">{{ $t(`${sbj.code}`) }}</h4>
                                <template v-for="(sbj1, i1) in sbj.subjects">
                                    <template v-for="(sbj2, i2) in sbj1.course">
                                        <div class="info-item">
                                            <div class="info-label">{{ sbj1.code != 'english' ?
                                                $t('p_subject_category_name_iSmart') + ": " + $t(sbj1.code) :
                                                $t(sbj2.unit_name) }}: </div>
                                            <div class="info-body">
                                                <div class="info-body-content">
                                                    <div class="info-body-2">
                                                        <div class="progress">
                                                            <div class="progress-process"
                                                                v-bind:style="{ width: calcPercent(sbj2.completed, sbj2.total) + '%' }">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="info-body-3"><span class="number">{{ sbj2.completed
                                                    }}</span>
                                                        {{ $t('of') }}
                                                        {{ sbj2.total }} {{ $t(`${sbj2.unit}`) }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </template>
                            </template>
                        </div>
                        <div v-else>
                            <h2 style="color: #000; text-align: center; font-size:20px">{{ $t('lisa_web_no_data') }}
                            </h2>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="tab == 'report'" class="card card-parents">
                <div class="card-header">
                    <div class="card-title">{{ $t('usage_reports') }}</div>
                </div>
                <div class="card-body" style="padding-left:90px">
                    <div class="card-content">
                        <div class="report">
                            <div class="report-1">
                                <!-- <div class="title">{{$t('completed')}}:</div> -->
                                <div v-if="emptyReportDay">
                                    <div v-if="report_day.length > 0">
                                        <template v-for="(subjects, index) in report_day">
                                            <div v-for="(category_code, index) in subjects.program"
                                                v-if="formatDay(subjects.day_time) == day_select">
                                                <div class="title">{{ $t(`${category_code.code}`) }}:</div>
                                                <div v-for="(course, index) in category_code.subjects" class="">
                                                    <div class="info-item" v-for="(cour, index) in course.course">
                                                        <div class="info-label">
                                                            <!-- {{ $t(cour.unit_name) }} -->
                                                            {{ course.code != 'english' ? $t(course.code) :
                                                                $t(cour.unit_name) }}:
                                                        </div>
                                                        <div class="info-body">
                                                            <div class="info-body-content">
                                                                <div class="info-body-1"><span class="number">{{
                                                                    cour.completed }}</span>
                                                                    {{ $t(`${cour.unit}`) }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                                <div v-else>
                                    <p v-if="!child_account"
                                        style="padding-top:5px;color: #1B1B1B;font-size: 16px;font-weight: 400;">
                                        {{ $t('empty_report_day') }}</p>
                                    <p v-else style="padding-top:5px;color: #1B1B1B;font-size: 16px;font-weight: 400;">
                                        {{ $t('lisa_web_no_data') }}</p>
                                </div>
                            </div>
                            <div class="report-2">
                                <div v-if="chart">
                                    <div class="calendar-header-char d-flex justify-content-end">
                                        <div class="calendar-header d-flex align-content-between">
                                            <div class="calendar-header-tool">
                                                <span class="calendar-prev" href="#" @click="prevDayChart">
                                                    <img src="/themes/ito/images/icons/icon-calander-prev.svg" alt="">

                                                </span>
                                                <span class="calendar-next" href="#" @click="nextDayChart">
                                                    <img src="/themes/ito/images/icons/icon-calander-next.svg" alt="">
                                                </span>
                                            </div>
                                            <div class="calendar-header-title desc">
                                                <p style="font-size: 10px; margin:0">{{ $t('this_week') }}</p>
                                                <p style="font-size: 14px; margin:0">{{ $t('from') }}
                                                    <b>{{ firstDateOfweek }}
                                                        {{ $t(`${month_label_1}`) | }}</b> {{ $t('to') }}
                                                    <b>{{ lastDateOfweek }}
                                                        {{ $t`${(month_label_1)}` }}</b>
                                                </p>
                                            </div>
                                            <div class="calendar-header-char d-flex justify-content-end">
                                                <span href="" @click.prevent=changeChart()>
                                                    <img src="/themes/ito/images/btn-calander-char1.svg" alt="">
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="calendar">
                                    <div class="calendar-body">
                                        <div class="calendar-days">
                                            <div class="calendar-header d-flex align-content-between">
                                                <div class="calendar-header-tool">
                                                    <span class="calendar-prev" href="#" @click="prevDay">
                                                        <img src="/themes/ito/images/icons/icon-calander-prev.svg"
                                                            alt="">

                                                    </span>
                                                    <span class="calendar-next" href="#" @click="nextDay">
                                                        <img v-if="currentMonth"
                                                            src="/themes/ito/images/icons/icon-calander-next.svg"
                                                            alt="">
                                                        <img v-else
                                                            src="/themes/ito/images/icons/icon-calander-next-1.svg"
                                                            alt="">
                                                    </span>
                                                </div>
                                                <div class="calendar-header-title">{{ $t(month_label) }} {{ year }}
                                                </div>
                                                <div class="calendar-header-char d-flex justify-content-end">
                                                    <!-- <a href="" @click.prevent=changeChart()>
                                                        <img src="/themes/ito/images/btn-calander-char.svg" alt="">
                                                    </a> -->
                                                </div>
                                            </div>
                                            <div class="calendar-row calendar-row-1">
                                                <div class="calendar-col">{{ $t('mon') }}</div>
                                                <div class="calendar-col">{{ $t('tue') }}</div>
                                                <div class="calendar-col">{{ $t('wed') }}</div>
                                                <div class="calendar-col">{{ $t('thu') }}</div>
                                                <div class="calendar-col">{{ $t('fri') }}</div>
                                                <div class="calendar-col">{{ $t('sat') }}</div>
                                                <div class="calendar-col">{{ $t('sun') }}</div>
                                            </div>

                                            <div class="calendar-row" v-for="(calander, index) in calanders"
                                                :key="index">
                                                <template v-for="(day, index) in calander">
                                                    <div class="calendar-col" v-if="day.day == ''" />

                                                    <div class="calendar-col day disable"
                                                        v-else-if="day.disabled == true">
                                                        <div class="text">{{ day.day }}</div>
                                                    </div>
                                                    <!-- <div :style="checkActive(day.day) || (day.current == true) ? 'background:#95C43C; color: #ffffff': '' " class="calendar-col day" :class="day_select == day.day? 'border' : ''" v-else-if="day.day != ''" @click="Test(day)"> -->
                                                    <div :style="checkActive(day.day) ? 'background:#95C43C; color: #ffffff' : ''"
                                                        class="calendar-col day"
                                                        :class="day_select == day.day ? 'border' : ''"
                                                        v-else-if="day.day != ''" @click="Test(day)">
                                                        <div class="text">{{ day.day }}</div>

                                                        <div v-for="(day_complete_count, index1) in report_day.filter(i => formatDay(i.day_time) == day.day)"
                                                            class="alert" v-bind:key="index1">
                                                            {{ day_complete_count.day_complete_count }}
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div v-else class="card-content">
                        <h2 style="color: #000; text-align: center; font-size:20px">{{$t('lisa_web_no_data')}}</h2>
                    </div> -->
                </div>
            </div>
            <div v-if="tab == 'report' && (user.account_type == 2 || user.student_type != 0)" class="card reports">
                <div class="card-header">
                    <div class="card-title">{{ $t('ebook_report') }}</div>
                </div>
                <div class="card-body">
                    <div class="card-content">
                        <div class="" style="padding: 30px; display: flex; align-items: baseline;">
                            <div class="form-group">
                                <label class="label-input">{{ $t('grade') }}</label>
                                <select class="ito-input" name="grade" v-model="grade" :title="$t('choose_a_grade')">
                                    <option value="">
                                        {{ $t('choose_a_grade') }}
                                    </option>
                                    <option value="6">6</option>
                                    <option value="7">7</option>
                                    <option value="8">8</option>
                                    <option value="9">9</option>
                                </select>
                            </div>
                            <div class="form-group" style="margin-left:30px">
                                <label class="label-input">{{ $t('subject') }}</label>
                                <select class="ito-input" name="subject" v-model="subject" :title="$t('subject')">
                                    <option value="">
                                        {{ $t('subject') }}
                                    </option>
                                    <option value="math">{{ $t('class_math') }}</option>
                                    <option value="science">{{ $t('class_science') }}</option>
                                    <!-- <option value="english">{{$t('english')}}</option> -->
                                </select>
                            </div>
                            <div>
                                <button v-if="view_table" class="lisa-btn-fit active" style="border: none"
                                    @click="getEbookReports">
                                    {{ $t('preview') }}
                                </button>
                                <button v-if="!view_table" class="lisa-btn-fit" style="border: none">
                                    {{ $t('preview') }}
                                </button>
                            </div>
                        </div>
                        <div v-if="show_result">
                            <div class="tbl-report" v-if="ebook_reports_page">
                                <table v-if="ebook_reports_page.length > 0">
                                    <tr>
                                        <th>{{ $t('ebook_report_time') }}</th>
                                        <th>{{ $t('ebook_report_quiz_name') }}</th>
                                        <th>{{ $t('ebook_report_page') }}</th>
                                        <th>{{ $t('ebook_report_result') }}</th>
                                        <th>{{ $t('ebook_report_score') }}</th>
                                        <th>{{ $t('ebook_report_time_spend') }}</th>
                                    </tr>
                                    <template v-for="(report, index) in ebook_reports_page">
                                        <tr>
                                            <td>{{ timeConverterEbook(report.time) }}</td>
                                            <td>{{ report.quiz_name }}</td>
                                            <td>{{ report.page }}</td>
                                            <td>{{ report.result }}</td>
                                            <td>{{ report.score }}</td>
                                            <td>{{ report.time_spend }}</td>
                                        </tr>
                                    </template>
                                </table>
                                <div v-if="ebook_reports.length > 8" class="paging d-flex align-items-center"
                                    style="margin-top: 12px">
                                    <p style="margin:0;font-size:14px;color:#0D0D0C; margin-right: 15px ">
                                        {{ indexStart + 1 }}-{{ indexEnd }} {{ $t('of') }} {{ ebook_reports.length }}
                                    </p>
                                    <span v-if="pageNumber != 1" @click="pageNumber > 1 ? pageNumber-- : pageNumber"
                                        style="cursor: pointer; margin-right: 10px"> <img
                                            src="/themes/ito/images/icon-pre-active.svg" alt=""> </span>
                                    <span v-else @click="pageNumber > 1 ? pageNumber-- : pageNumber"
                                        style="cursor: pointer; margin-right: 10px"> <img
                                            src="/themes/ito/images/icon-pre.svg" alt=""> </span>

                                    <span v-if="pageNumber != maxPage"
                                        @click="pageNumber < maxPage ? pageNumber++ : pageNumber"
                                        style="cursor: pointer"> <img src="/themes/ito/images/icon-next1-active.svg"
                                            alt=""> </span>
                                    <span v-else @click="pageNumber < maxPage ? pageNumber++ : pageNumber"
                                        style="cursor: pointer">
                                        <img src="/themes/ito/images/icon-next1.svg" alt=""> </span>
                                </div>
                            </div>
                            <div class="tbl-report" v-else>
                                <div class="text-center"
                                    style="color:#000; font-size: 16px; font-weight: 700; margin: 15px auto;">
                                    {{ $t('lisa_web_empty_ebook_report') }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="tab == 'certificates'" class="card card-parents">
                <div class="card-header">
                    <div class="card-title">{{ $t('completion_certificates') }}</div>
                </div>
                <div class="card-body">
                    <div class="card-content cert">
                        <div v-if="certs.length > 0">
                            <div class="row">
                                <template v-for="(acd, index) in certs">
                                    <div class="col-md-4">
                                        <div class="item-academic">
                                            <img src="/themes/ito/images/preview1.svg" />
                                            <div class="item-academic-class">School year</div>
                                            <div class="item-academic-name">{{ acd.school_year }}</div>
                                            <div class="btn-preview"
                                                @click="reviewCert(acd.class_id, acd.school_year, acd.type)">
                                                {{ $t('preview') }}
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div v-else>
                            <p class="desc_certificates">{{ $t('no_certificates') }}</p>
                        </div>
                    </div>
                    <!-- <div v-else class="card-content cert">
                        <h2 style="color: #000; text-align: center; font-size:20px">{{$t('lisa_web_no_data')}}</h2>
                    </div> -->
                </div>
            </div>
            <div v-if="tab == 'academic'" class="card card-parents">
                <div class="card-header">
                    <div class="card-title">{{ $t('academic_report') }}</div>
                </div>
                <div class="card-body">
                    <div class="card-content cert">
                        <div v-if="is_academic != -1">
                            <template v-for="(acd, index) in academics">
                                <div class="row">
                                    <template v-for="(item, index) in acd.class_term">
                                        <div class="col-md-4" v-if="item.isARVisible == true">
                                            <div class="item-academic">
                                                <img src="/themes/ito/images/preview.svg" />
                                                <div class="item-academic-class">{{ acd.class_name }}</div>
                                                <div class="item-academic-name">{{ item.term_name }}</div>
                                                <div class="btn-preview"
                                                    @click="reviewAcademic(acd.class_id, item.term_id)">
                                                    {{ $t('preview') }}
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </div>
                        <div v-else>
                            <p class="desc_certificates">{{ $t('empty_academic_report') }}</p>
                        </div>
                    </div>
                    <!-- <div v-else class="card-content cert">
                        <h2 style="color: #000; text-align: center; font-size:20px">{{$t('lisa_web_no_data')}}</h2>
                    </div> -->
                </div>
            </div>
            <div v-if="tab == 'iclassreport'" class="card card-parents">
                <IclassReport :reportList="reportList" :isPrimarySchool="grade_selected <= 5"/>
            </div>
        </div>
    </div>


</template>

<script src="https://cdn.jsdelivr.net/npm/chart.js@3.0.0/dist/chart.min.js"></script>
<script src="https://cdn.jsdelivr.net/npm/chartjs-plugin-datalabels@2.0.0"></script>
<script>
    import axios from "axios";
    import {pushQueries, soundClick, toPercent, convertSecondToText1} from '../../utils/utils';
    import {mapGetters} from 'vuex';
    import {getParentReportGrade, getParentReportMonth, getParentReport, getCertificateReport, getAcademicReport, getEbookReport} from "../../models/parent";
    import { Bar } from 'vue-chartjs/legacy';    
    import IclassReport from './ParentIclassReport.vue';

    export default {
        name: "ParentReport",
        title: 'Parents - Report',
        components: {
            IclassReport
        },

        data() {
            const date = new Date();
            const year = date.getFullYear();
            const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            const months_1 = ["jan_1", "feb_1", "mar_1", "apr_1", "may_1", "jun_1", "jul_1", "aug_1", "sep_1", "oct_1", "nov_1", "dec_1"];
            const month = date.getMonth() + 1;
            const month_label = months[month - 1];
            const month_label_1 = months_1[month - 1];
            const calanders = this.getCalanders(month, year);
            const role_type = localStorage.getItem('role_type');
            const user_info = this.$store.state.user_info;
            let child_account = localStorage.getItem('child_account');
            child_account = child_account?JSON.parse(child_account):null;
            if(child_account == null && user_info.childrens){
                child_account = user_info.childrens[0];
            }

            return {
                empty_use_report: false,
                report_program: [],
                reports: [],
                pageNumber: 1,
                maxPage: 0,
                indexStart: 0,
                indexEnd : 0,
                reports: [],
                report_total_subject: [],
                report_total_vocab: [],
                report_day: [],
                isLoading: true,
                year: year,
                months: months,
                month: month,
                months_1: month,
                month_label: month_label,
                month_label_1: month_label_1,
                calanders: calanders,
                day_select: date.getDate(),
                day_active_month: [],
                dates: [],
                tab: 'report',
                certs: [],
                academics: [],
                grade: '',
                subject: '',
                ebook_reports: [],
                ebook_reports_page: null,
                view_table: false,
                show_result: false,
                chart: false,
                firstDateOfweek: '',
                lastDateOfweek: '',
                listActiveCalender: [],
                program: [],
                dataReport: [],
                dataReportDay: [],
                reportList: [],
                hasIclass: false,
                emptyReportDay: true,
                grade_selected: child_account ? child_account.grade : user_info.grade,
                currentMonth: false,
                role_type: role_type,
                child_account: child_account,
                user: '',
                is_academic: false,
                eco_url: process.env.VUE_APP_ECO_URL,
            };
        },

        created() {
            this.$store.commit('setMenuActive', 'parent');

            this.fetch();
        },
        computed: {
            ...mapGetters([
                'user_info'
            ], () => {
                if (this.user_info) {
                    return this.user_info
                }

                return this.user
            }),
        },
        watch: {
            'grade': function (newVal, oldVal) {
                this.pageNumber = 1;
                this.show_result = false;
                if (newVal != '' && this.subject != '') {
                    this.view_table = true;
                } else {
                    this.view_table = false;
                }
            },
            'subject': function (newVal, oldVal) {
                this.pageNumber = 1;
                this.show_result = false;
                if (newVal != '' && this.grade != '') {
                    this.view_table = true;
                } else {
                    this.view_table = false;
                }
            },
            'pageNumber' : function(newVal, oldVal){
                this.getEbookReports();
            }
        },
        async mounted () {
            this.grade_selected = localStorage.getItem('grade') ? localStorage.getItem('grade') : this.user_info.grade;
            const date = new Date();
            this.firstDateOfweek =  date.getDate() -  date.getDay() + 1;
            this.lastDateOfweek =  date.getDate() -  date.getDay() + 7;
            let dayInWeek = date.getDay();
            let arrColorDay = [];
            this.dates = ['Mon','Tue','Web','Thu','Fri','Sat','Sun'];
            for(var i = 1; i < 8; i++){
                if(i==dayInWeek){
                    arrColorDay.push('rgba(0,0,0,1)')
                    this.dates[i-1] = 'Today'
                }else if(i>dayInWeek){
                    arrColorDay.push('#C4C4C4')
                }else{
                    arrColorDay.push('rgba(0,0,0,0.6)')
                }
            }
            if (this.role_type == 'parent'){
                this.user = this.child_account
            }else{
                this.user = this.user_info
            }
            const params = {

            };
            const reportResponse = await this.getIclass(params, '/report/iclass/list').catch(error => {
                console.error('Error fetching:', error);
            });
            if (reportResponse.data?.results?.length && reportResponse.data.results.length > 0) {
                this.hasIclass = true;
                for (const item of reportResponse.data.results) {
                    this.reportList.push({ id: item.id, name: item.name, start_date: item.start_date, start_time: item.start_time, end_time: item.end_time });
                }
            }
        },

        methods: {
            getCookie(key) {
                const cookies = document.cookie
                    .split(';')
                    .map(cookie => cookie.split('='))
                    .reduce((accumulator, [key, value]) =>
                        ({ ...accumulator, [key.trim()]: decodeURIComponent(value) }), {});
                return cookies[key];
            },
            async getIclass(params, url) {
                this.$store.commit("setLoading", true);
                this.loading = true;
                const token = this.getCookie('_wid');
                const res = await axios.get(process.env.VUE_APP_API_ICLASS + url,
                    {
                        params,
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                            "Access-Control-Allow-Origin": "*",
                            "Access-Control-Allow-Methods": "OPTIONS",
                            "Access-Control-Allow-Headers": "Content-Type, Authorization",
                            "Access-Control-Allow-Credentials": "true",
                            "Cache-Control": "no-cache, no-store, must-revalidate",
                            "Pragma": "no-cache",
                            "Expires": "0",
                            "X-System": "ipro2"
                        }
                    }
                )
                this.$store.commit("setLoading", false);
                this.loading = false;
                return res;
            },
            mapSubject(program, report){
                this.dataReport = []
                program.forEach(e => {
                    let itemDataReport = [];
                    report.forEach(t => {
                        if(e == t.program){
                            itemDataReport.push(t)
                        }
                    })
                    this.dataReport.push({'programName':e, 'subject':itemDataReport})
                })
            },
            mapSubjectDay(program, reportDay){
                let test = []
                this.dataReportDay = []
                reportDay.forEach(rpd => {
                    test = []
                    program.forEach(e => {
                        let itemDataReport = [];
                        rpd.subjects.forEach(t => {
                            if(e == t.program){
                                itemDataReport.push(t)
                            }
                        })
                        test.push({'programName':e, 'subject':itemDataReport})
                    })
                    this.dataReportDay.push({'day_time':rpd.day_time, 'subjects' :test })
                });
            },

            timeConverterEbook(UNIX_timestamp) {
                var a = new Date(UNIX_timestamp * 1000);
                var months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
                var year = a.getFullYear();
                var month = months[a.getMonth()];
                var date = a.getDate() < 10 ? '0' + a.getDate() : a.getDate();
                var hour = a.getHours() < 10 ? '0' + a.getHours() : a.getHours();
                var min = a.getMinutes() < 10 ? '0' + a.getMinutes() : a.getMinutes();
                var sec = a.getSeconds() < 10 ? '0' + a.getSeconds() : a.getSeconds();
                var time = hour + ':' + min + ':' + sec + ' - ' + date + '/' + month + '/' + year;
                return time;
            },
            checkActive(day){
                return this.listActiveCalender.includes(day)
            },
            formatTime(time){
                return convertSecondToText1(time);
            },
            formatDay(timestamp) {
                var date = new Date(timestamp * 1000);
                var day = date.getDate();
                return day;
            },
            changeChart(){
                // this.chart = !this.chart;
            },
            changeTab(tab) {
                this.tab = tab;
            },
            getEbookReports() {
                const that = this;
                const params = {
                    'username': that.child_account ? that.child_account.username : this.user_info.username,
                    'subject': that.subject,
                    'grade': that.grade,
                    'page' : that.pageNumber
                }

                axios.all([
                    getEbookReport(params),
                ]).then(axios.spread((report_response) => {
                    that.show_result = true;
                    that.ebook_reports = report_response.data.results.ebook_reports;

                    if (that.ebook_reports) {
                        if(that.ebook_reports.length > 0){
                            let page_limit = 8;
                            this.indexStart = page_limit*(that.pageNumber-1);
                            this.indexEnd =  this.indexStart + page_limit;
                            this.maxPage = Math.floor(that.ebook_reports.length / page_limit) + 1
                            if(this.maxPage == that.pageNumber){
                                this.indexEnd = that.ebook_reports.length
                            }
                            that.ebook_reports_page = that.ebook_reports.slice(this.indexStart, this.indexEnd)
                        }
                    }
                }));

                // that.ebook_reports = [
                //     {
                //         'time' : 'time',
                //         'quiz_name' : 'quiz name1',
                //         'result' : 'result',
                //         'score' : 'scrore',
                //         'time_spend' : 'time spend'
                //     },
                // ]
            },
            getAcademic() {
                const that = this;

                that.$store.commit("setLoading", true);
                const formData = new FormData();
                formData.append('eco_user_id', that.user_info.eco_user_id ? that.user_info.eco_user_id : '');
                getAcademicReport(formData).then((data) => {
                    that.$store.commit("setLoading", false);
                    if (data.status == 200) {
                        that.academics = data.data.data;
                        this.is_academic = that.academics.findIndex(x => {
                            return x.class_term.length > 0
                        })
                    }
                }).catch(({response}) => {
                    that.$store.commit("setLoading", false);
                    alert(response.data.results);
                });
            },
            reviewAcademic(classId, termId) {
                let eco_user_id = this.user_info.eco_user_id ? this.user_info.eco_user_id : '';
                let url = this.eco_url + '/api_eco.php/get_ar?class_id=' + classId + '&eco_id=' + eco_user_id + '&class_term=' + termId;
                this.redirect_blank(url);
            },
            getCerts() {
                this.$store.commit("setLoading", true);
                const formData = new FormData();
                formData.append('eco_user_id', this.user_info.eco_user_id ? this.user_info.eco_user_id : '');
                getCertificateReport(formData).then((data) => {
                    this.$store.commit("setLoading", false);
                    if (data.status == 200) {
                        const data1 = data.data.data.n.map(obj => {
                            return { ...obj, type: 'n' };
                        });
                        const data2 = data.data.data.pe.map(obj => {
                            return { ...obj, type: 'pe' };
                        });
                        const mergedData = data1.concat(data2);
                        this.certs = mergedData
                    }
                }).catch(({response}) => {
                    this.$store.commit("setLoading", false);
                });
            },
            reviewCert(classId, year, type) {
                let eco_user_id = this.user_info.eco_user_id ? this.user_info.eco_user_id : '';
                let url = this.eco_url + '/api_eco.php/get_cc?class_id=' + classId + '&eco_id=' + eco_user_id + '&school_year=' + year + '&type=' + type;
                this.redirect_blank(url);
            },
            redirect_blank(url) {
                var a = document.createElement('a');
                a.target = "_blank";
                a.href = url;
                a.click();
            },
            getDaysArray(year, month) {
                const monthIndex = month - 1;
                const date = new Date(year, monthIndex, 1);
                const result = [];
                while (date.getMonth() === monthIndex) {
                    result.push(date.getDate());
                    date.setDate(date.getDate() + 1);
                }
                return result;
            },

            Test(day){
                this.day_select = day.day;
                this.emptyReportDay = this.listActiveCalender.includes(this.day_select);
            },
            getParentReportGrade(){
                const that = this;
                const params = {
                    // grade: localStorage.getItem('grade') ? localStorage.getItem('grade') : this.user_info.grade,
                    // student_id: this.child_account.id,
                    // role: localStorage.getItem('role_type') ? localStorage.getItem('role_type') : "student",
                    grade: that.child_account ? that.child_account.grade : this.user_info.grade,
                    role: that.role_type,
                    student_id: that.child_account ? that.child_account.id : 0
                };  
                axios.all([
                    getParentReportGrade(params)
                ]).then(axios.spread((report_response) => {
                    that.isLoading = false;
                    if (report_response.data.code != 0) {
                        return;
                    }
                    that.reports = report_response.data.results || [];
                    that.report_program = report_response.data.results.program || [];
                }));
            },
            fetch(page = 1) {
                const that = this;
                that.calanders = that.getCalanders(this.month, this.year);
                that.isLoading = true;
                that.page = page;
                that.getCerts();
                that.getAcademic();
                that.getParentReportGrade();
            },

            prevDay(e) {
                const that = this;
                // that.day_select = '';
                if (this.month == 1) {
                    this.month = 12;
                    this.year = this.year - 1;
                } else {
                    this.month = this.month - 1;
                }
                this.currentMonth = true
                this.month_label = this.months[this.month - 1];
                that.$store.commit("setLoading", true);
                this.calanders = this.getCalanders(this.month, this.year);
            
                e.preventDefault();
            },
            nextDay(e) {
                if(this.currentMonth){
                    const that = this;
                    // that.day_select = '';
                    if (this.month == 12) {
                        this.month = 1;
                        this.year = this.year + 1;
                    } else {
                        this.month = this.month + 1;
                    }
                    const d = new Date();
                    let month = d.getMonth();
                    let year = d.getFullYear();
                    if(this.month == month+1 && this.year == year){
                        this.currentMonth = false
                    }

                    this.month_label = this.months[this.month - 1];
                    that.$store.commit("setLoading", true);

                    this.calanders = this.getCalanders(this.month, this.year);
                }

                e.preventDefault();
            },
            prevDayChart(e){
                this.month_label_1 = this.months_1[this.month - 1];
                this.$store.commit("setLoading", true);
                e.preventDefault()
            },
            nextDayChart(e){
                this.month_label_1 = this.months_1[this.month - 1];
                this.$store.commit("setLoading", true);
                e.preventDefault()
            },

            calcPercent(process, total) {
                return toPercent(process, total);
            },

            chunks(array, size) {
                var results = [];
                while (array.length) {
                    results.push(array.splice(0, size));
                }
                return results;
            },

            getSoundClick() {
                soundClick();
            },

            getCalanders(month, year) {
                const that = this;
                const date = new Date();
                const data = [];
                const firstDay = this.getFirstDayInMonth(month, year);
                const lastDay = this.getDaysInMonth(month, year);
                const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
                const current_date = date.getDate();
                const current_month = date.getMonth() + 1;
                const current_year = date.getFullYear();
                const params = {
                    year: year,
                    month: month,
                    role: that.role_type,
                    student_id: that.child_account ? that.child_account.id : 0,
                    grade: that.grade_selected,
                };
                that.day_active_month = [];
                axios.all([
                    // getParentReport(params),
                    getParentReportMonth(params),
                ]).then(axios.spread((second_response, report_response) => {
                    that.isLoading = false;

                    that.$store.commit("setLoading", false);

                    if (second_response.data.code != 0) {
                        return;
                    }
                    that.reports = second_response.data.results || [];
                    that.report_day = second_response.data.results.report_day || [];
                    that.listActiveCalender = [];
                    second_response.data.results.login_day?.forEach(e => {
                        that.listActiveCalender.push(that.formatDay(e))
                    })
                    that.emptyReportDay = that.listActiveCalender.includes(that.day_select);

                    if (that.report_day.length != 0) {
                        that.calanders.forEach(function (element) {
                            if (element.length > 0) {
                            element.forEach(function (item) {
                                if (typeof item.current != 'undefined' && item.current) {
                                that.day_select = item.day;
                                }
                            });
                            }
                        });
                        that.report_day.forEach(function (element) {
                            that.day_active_month.push({
                                'day_active': that.timeConverter(element.day_time),
                                'day_number': element.day_complete_count,
                                // 'day_subject': element.subjects,
                                // 'day_vocabs': element.vocabulary,
                            });
                            that.empty_use_report = true;
                            if (that.formatDay(element.day_time) === that.day_select) {
                                that.empty_use_report = false;
                            }
                        })
                    } else {
                        that.day_active_month = [];
                    }
                }));
                for (var i = 1; i < firstDay; i++) {
                    data.push({
                    day: ""
                    });
                }

                for (var i = 1; i <= lastDay; i++) {
                    let disabled = false;
                    let current = false;
                    let day_complete_count = false;
                    if (current_year < year || (current_year == year && current_month < month) || (current_year == year && current_month == month && current_date < i)) {
                        disabled = true;
                    }

                    if ((current_year == year && current_month == month && current_date > i)) {
                        day_complete_count = true;
                    }

                    if (current_year == year && current_month == month && current_date == i) {
                        current = true;
                    }
                    const d = new Date(year, month - 1, i).getDay();
                    data.push({
                        day: i,
                        label: days[d],
                        disabled: disabled,
                        current: current,
                        day_complete_count: day_complete_count,
                    });
                }

                const lastDays = Math.ceil(data.length / 7) * 7 - data.length;
                for (var i = 0; i <= lastDays; i++) {
                    data.push({
                        day: ""
                    });
                }

                return this.chunks(data, 7);
            },

            getDaysInMonth(month, year) {
                // Here January is 1 based
                // Day 0 is the last day in the previous month
                return new Date(year, month, 0).getDate();
                // Here January is 0 based
                // return new Date(year, month+1, 0).getDate();
            },

            getFirstDayInMonth(month, year) {
                return new Date(year, month - 1, 1).getDay();
            },

            timeConverter(UNIX_timestamp){
                var a = new Date(UNIX_timestamp * 1000);
                var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
                var year = a.getFullYear();
                var month = months[a.getMonth()];
                var date = a.getDate();
                var hour = a.getHours();
                var min = a.getMinutes();
                var sec = a.getSeconds();
                var time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec ;
                return date;
            },
        }
    }
</script>

<style scoped>
/* .container{
      margin-top: 200px;
    } */
.item-academic-class {
    font-family: Nunito;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    letter-spacing: 0em;
    text-align: center;
    margin-top: 10px;
    color: #1B1B1B;
}

.item-academic-name {
    font-family: Nunito;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0em;
    text-align: center;
    color: #1B1B1B;
}

.btn-preview {
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%), #00A3FF;
    border-radius: 8px;
    padding: 8px 20px 8px 20px;
    color: #fff;
    cursor: pointer;
    width: fit-content;
    align-self: center;
    margin-top: 5px;
}

.item-academic {
    display: flex;
    text-align: center;
    flex-direction: column;
    justify-content: center;
    padding: 20px 40px;
    margin: 0 !important;
}

.desc_certificates {
    color: #1B1B1B;
    font-weight: 700;
    font-size: 16px;
    text-align: center;
    margin: 0;
    padding: 30px 0;
}

.ito-input {
    width: 150px !important;
    margin: 0 10px;
    border-radius: 8px;
    width: 300px;
    height: 36px;
    /* border: 1px solid rgba(228, 228, 228, 0.6); */
    padding: 0 10px;
    font-size: 14px !important;
}

.ito-input option {
    font-size: 14px !important;
}

.lisa-btn-fit {
    height: 36px;
    display: flex;
    align-items: center;
}


table {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    /* border: none !important; */
    width: 100%;
}

td,
th {
    border: 1px solid #FFFFFF;
    text-align: left;
    border-left: none;
    border-right: none;
    font-size: 14px;
    color: #000000;
    height: 37px;
    padding-left: 20px;
}

th {
    background: #03A4FF;
    color: #FFFFFF;
    height: 37px;
}

tr:nth-child(2n + 1) {
    background: #EEEEEE;
}

tr:nth-child(2n) {
    background-color: #E3E3E3;
    ;
}

.tbl-report {
    padding: 0 30px 30px;
}

/* .tbl-report table tr{
        background: #03A4FF;
    } */

.label-input {
    font-size: 14px;
    color: #151522;
    font-weight: 700;
}

/* #page-header{
        position: fixed;
        top: 200px;
        z-index: 9999;
    } */
.info-item2 {
    flex-direction: column;
}

.info-item {
    /* margin: 8px;
        padding: 0;
        height: 24px;
        display: flex;
        justify-content: flex-start; */
    padding: 0;
    margin: 0;
    margin-bottom: 8px;
}

.info-item2 .title2 {
    margin-bottom: 10px;
}

.info-item2 .desc {
    margin-left: 54px;
}

.test {
    z-index: 9999;
    position: absolute;
    font-size: 10px;
    color: #1B1B1B;
    top: -15px;
    left: 11px;
    font-weight: 700;
}

.test1 {
    z-index: 9999;
    position: absolute;
    font-size: 10px;
    color: #1B1B1B;
    bottom: 3px;
    right: -40px;
    font-weight: 700;
}

.box-calendar {
    position: relative;
}

.calendar-header-title.desc {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 20px;
    font-weight: 400;
}

.paging {
    width: 100%;
    justify-content: flex-end;
}

.info-label {
    display: flex;
    justify-content: flex-end;
    margin-right: 12px;
}

.info-body {
    display: flex;
}

.info-report-day {
    width: 100%;
    display: flex;
}

.info-report-item-1 {
    width: 178px;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 8px;
}

.info-report-item-2 {
    margin-left: 12px;
    margin-bottom: 8px;
}

.report-1 {
    width: 48% !important;
    /* margin-left: 27px; */
}

.info-body-3 {
    width: unset !important;
}
</style>
